import React, { useReducer } from 'react';
import './PaxPicker.css';
import Room from './Room';
import { DEFAULT_PAX_VALUE } from '../../constants';
import {
  SET_EDIT_MODE,
  UPDATE_ROOM,
  REMOVE_ROOM,
  ADD_ROOM,
  MAX_ROOM_COUNT,
} from '../Constant/constants';
import PaxDispatch from './PaxDispatch';
import utils from '../../utils';

const initialState = {
  value: DEFAULT_PAX_VALUE,
  editIndex: null,
};
const paxReducer = (state, action) => {
  switch (action.type) {
    case ADD_ROOM:
      // eslint-disable-next-line no-case-declarations
      const updatedVlaues = state.value.concat(DEFAULT_PAX_VALUE);
      return {
        editIndex: updatedVlaues.length - 1,
        value: updatedVlaues,
      };
    case REMOVE_ROOM:
      return {
        ...state,
        value: state.value.filter((room, index) => index !== action.index),
      };
    case SET_EDIT_MODE:
      return { ...state, editIndex: action.index };
    case UPDATE_ROOM:
      return {
        ...state,
        value: state.value.map((room, index) => (index === action.index ? action.room : room)),
      };
    default:
      throw new Error('No such action defined!');
  }
};

const PaxPicker = ({
  value,
  handleChange,
  roomAdditionAllowed,
  roomsAndGuestsError,
  roomsAndGuestsErrorMessage,
  paxConfig,
  roomCount = MAX_ROOM_COUNT,
  className = '',
}) => {
  const [{ value: pax, editIndex }, dispatch] = useReducer(paxReducer, {
    ...initialState,
    value: value || DEFAULT_PAX_VALUE,
  });
  const isRoomAddAllowed = roomAdditionAllowed || pax.length < roomCount;

  return (
    <div className={`paxpicker-container ${className}`}>
      <div className="pax-container">
        <PaxDispatch.Provider value={dispatch}>
          {pax.map((room, index) => (
            <Room
              key={index}
              room={room}
              isEdit={editIndex === index}
              roomIndex={index}
              removable={index !== 0}
              paxConfig={paxConfig}
            />
          ))}
        </PaxDispatch.Provider>
        {roomsAndGuestsError && <p className="errorTextPax">{roomsAndGuestsErrorMessage}</p>}
      </div>
      <div className={`btnContainer ${isRoomAddAllowed ? '' : 'singleBtn'}`}>
        {isRoomAddAllowed && (
          <button type="button" className="addBtn" onClick={() => dispatch({ type: ADD_ROOM })}>
            + ADD ANOTHER ROOM
          </button>
        )}
        <button
          type="button"
          className="applyBtn primaryBtn btnApply fill btn btn-primary btn-sm"
          onClick={() => utils.isValidPax(pax) && handleChange(pax)}
        >
          APPLY
        </button>
      </div>
    </div>
  );
};

export default PaxPicker;
